// src/main.ts

import Vue from 'vue';
import './plugins/axios';
import './filters/currency';
import './filters/customFilters';
import './plugins/print';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import gaaVueLib from 'gaa-vue-lib';
import './assets/styles/app.scss';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import Print from 'vue-print-nb';
import GaaVueLib2 from 'gaa-vue-lib-v2';
import 'gaa-vue-lib-v2/style.css';

// Import the TypeScript Axios Interceptor
import interceptorsConfig from './config/interceptorsConfig';

Vue.use(VueFilterDateFormat);
Vue.use(Print);

Vue.use(gaaVueLib, { store });
Vue.use(GaaVueLib2, { vuetify });

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === 'production' ? false : true;
Vue.config.silent = process.env.NODE_ENV === 'production' ? false : true;

// Initialize Axios interceptors with store and router
interceptorsConfig(store, router);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  mounted() {
    window.onbeforeprint = () => {
      const element = document.querySelector<HTMLElement>('.v-main');
      if (element) {
        element.style.paddingTop = '0px';
      }
    };
    window.onafterprint = () => {
      const element = document.querySelector<HTMLElement>('.v-main');
      if (element) {
        element.style.paddingTop = '64px';
      }
    };

    store.dispatch('auth/initializeAuthChannel');
  },
}).$mount('#app');
